import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BOX_IMAGE, CHECKOUT_URL } from '../data/product';
const INCLUDES = ['6 professional modules', '5 professional bonuses', 'Visual diagnostic workflows', 'Fault-finding tools', 'Electrical testing guides', 'Diagnostic decision trees', 'Professional workshop references'];
export function Offer() {
  return <section id="offer" className="bg-paper px-4 py-6 sm:py-8" data-id="element-122" data-mp="tzd6qmcnnici">
      <div className="mx-auto max-w-3xl rounded-2xl border-2 border-auto bg-white p-4 shadow-[0_18px_40px_-20px_rgba(16,38,61,0.45)] sm:p-6" data-id="element-123" data-mp="p0jwd2so07gk">
        <p className="text-center font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-alert" data-id="element-124" data-mp="13yc6fffg03nd">
          Special Launch Offer
        </p>
        <h2 className="mt-1 text-center text-2xl text-navy sm:text-4xl" data-id="element-125" data-mp="2fbods0aev4ea">
          🔧 AUTOMOTIVE DIAGNOSTIC PRO™
        </h2>
        <p className="mt-1 text-center font-display text-lg uppercase leading-tight tracking-wide text-auto sm:text-2xl" data-id="element-126" data-mp="2acbjwvl4gx27">
          The Complete Visual Fault-Finding System For Automotive Technicians
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" data-id="element-127" data-mp="uhh1gq9uucs0">
          <img src={BOX_IMAGE} alt="AUTOMOTIVE DIAGNOSTIC PRO™ complete system" className="mx-auto mt-3 w-full max-w-[16rem]" loading="lazy" data-id="element-128" data-mp="zjg766t2hls4" />
        </a>

        <p className="mt-2 text-center font-display text-xl uppercase text-navy" data-id="element-129" data-mp="6vakvfmd7oq6">
          Complete 6-in-1 System
        </p>
        <ul className="mx-auto mt-2 grid max-w-xl gap-1 sm:grid-cols-2" data-id="element-130" data-mp="bqpt9s1lssf7">
          {INCLUDES.map(item => <li key={item} className="flex items-start gap-1.5 text-sm font-semibold leading-snug text-ink" data-id="element-131" data-mp="kl48xvq1q4yu">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-auto" aria-hidden="true" data-id="element-132" data-mp="3k7ufic8xxlq0" />
              {item}
            </li>)}
        </ul>

        <p className="mt-4 text-center font-display text-2xl uppercase leading-tight text-navy sm:text-3xl" data-id="element-133" data-mp="vefs3yxu3yzi">
          🔥 GET AUTOMOTIVE DIAGNOSTIC PRO™ TODAY —{' '}
          <span className="text-alert" data-id="element-134" data-mp="15621rquixq05">$26.90</span>
        </p>

        <div className="mt-3 flex justify-center" data-id="element-135" data-mp="157mt77ljksts">
          <CTAButton href={CHECKOUT_URL} external data-id="element-136" data-mp="107idhjsgk24m">
            🔧 GET INSTANT ACCESS
          </CTAButton>
        </div>

        <ul className="mt-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold uppercase tracking-wide text-ink/70 sm:text-xs" data-id="element-137" data-mp="chelyasjnstz">
          <li className="flex items-center gap-1.5" data-id="element-138" data-mp="li2reh3vgkv9">
            <ZapIcon className="h-4 w-4 text-auto" aria-hidden="true" data-id="element-139" data-mp="lfghwbxf7vae" />
            Immediate Digital Access
          </li>
          <li className="flex items-center gap-1.5" data-id="element-140" data-mp="1wwpymqp60980">
            <ShieldCheckIcon className="h-4 w-4 text-auto" aria-hidden="true" data-id="element-141" data-mp="1wv55n5ii0yc9" />
            7-Day Money-Back Guarantee
          </li>
        </ul>
      </div>
    </section>;
}